import { identityBiometricService, identityBiometricCheckService } from '@afterpaytouch/portal-api/consumer/identityBiometric'

export const { useCreateApplicantsMutation, useCreateInquiryIdMutation } = identityBiometricService

export const { useCheckBiometricStatusQuery } = identityBiometricCheckService
